export default __webpack_public_path__ + "static/media/client2.8079ddbf.png";